import { Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Params } from '@angular/router';
import { of, Subject, switchMap } from 'rxjs';

import { safeCompare } from '@shared-helpers/string-number-helpers';
import { IApplicationQueryParams } from '@shared-interfaces/api';

import { DatahubService } from '../../services/datahub.service';

@Component({
  selector: 'billing',
  templateUrl: './billing.component.html',
  standalone: false,
})
export class BillingComponent implements OnInit {
  private readonly updateCostCenterFormCtrlSubject$ = new Subject<number>();
  public readonly updateCostCenterFormCtrl$ = this.updateCostCenterFormCtrlSubject$.asObservable();

  constructor(
    private readonly datahub: DatahubService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.datahub.switchApprover$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: () => {
        this.switchGeneralForeman();
      },
      error: (err) => {
        console.error('Error switching approver:', err);
      },
    });

    this.activatedRoute.queryParams
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        switchMap((params: Params) => {
          const typedParams = params as IApplicationQueryParams;
          this.datahub.weDate.setWeDateWithString(typedParams.wedate, false);
          const approver = typedParams.approver || this.datahub.user.getApprover();

          if (safeCompare(approver, this.datahub.user.approvingId)) {
            return of(null);
          } else {
            return this.datahub.user.switchApprover$(approver).pipe(
              switchMap(() => {
                this.switchGeneralForeman();
                return of(null);
              }),
            );
          }
        }),
      )
      .subscribe({
        error: (err) => {
          console.error('Error during queryParams or approver switching:', err);
        },
      });
  }

  private notifyChildUpdateCostCenter(approvingCostCenter: number): void {
    this.updateCostCenterFormCtrlSubject$.next(approvingCostCenter);
  }

  private switchGeneralForeman(): void {
    this.notifyChildUpdateCostCenter(Number(this.datahub.user.approvingCostCenter));
    this.datahub.updateQueryParams();
  }
}
